/* eslint-disable no-param-reassign */
export default class MoveDomElement {
    /**
     * Save the current location in the DOM tree.
     * @param {Object} element
     */
    static setInitialDomTreeLocation(element) {
        element.initialParent = element.parentElement;
        element.initialNextSibling = element.nextElementSibling;
        element.initialPreviousSibling = element.previousElementSibling;
    }

    /**
     * Save the current location in the DOM tree.
     * @param {Object} element
     */
    static resetDomTreeLocation(element) {
        const parentHasChanged = !element.parentElement.isEqualNode(element.initialParent);
        const hasSameParentAsInitialNextSibling = element.initialNextSibling && element.initialNextSibling.parentElement.isEqualNode(element.initialParent);
        const hasSameParentAsInitialPreviousSibling = element.initialPreviousSibling && element.initialPreviousSibling.parentElement.isEqualNode(element.initialParent);

        if (parentHasChanged) {
            if (hasSameParentAsInitialNextSibling) {
                element.initialParent.insertBefore(element, element.initialNextSibling);
            } else if (hasSameParentAsInitialPreviousSibling) {
                element.initialParent.insertBefore(element, element.initialPreviousSibling.nextElementSibling);
            } else {
                element.initialParent.appendChild(element);
            }
        }
    }
}